import React from 'react';

import { Create,
         ReferenceInput,
         TextInput,
         AutocompleteInput,
         ImageField,
         ImageInput,
         SimpleForm, 
         required } from 'react-admin';

export const CreateOrderApproval = (props) => (
    <Create title="Create an Order Approval Request" {...props}>
        <SimpleForm redirect="list">            
            <ReferenceInput label="Order" source="order_id" reference="orders" validate={required()} >
                <AutocompleteInput optionText="id" options={{ fullWidth: true }} translateChoice={false}/>
            </ReferenceInput>
            <ReferenceInput label="Canvas" source="canvas_id" reference="canvases" validate={required()} >
                <AutocompleteInput optionText="id" options={{ fullWidth: true }} translateChoice={false}/>
            </ReferenceInput>
            <ImageInput source="image" label="Canvas preview image to be Approved" accept="image/*" validate={required()}>
                    <ImageField source="src" title="title" />
            </ImageInput>
            <TextInput source="notes" label="Notes to customer." validate={required()}/>
        </SimpleForm>
    </Create>
);